import Signin from 'pages/Authentication/Login'
import { Navigate } from 'react-router-dom';


const LoginRedirectWrapper = () => {
    const token = localStorage.getItem("token");
    const userProfile = localStorage.getItem("authUser");
    
    if (token && userProfile) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Signin />;
};

export default LoginRedirectWrapper;
